// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/transportation/voyages/voyage.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest, EmptyResponse } from "../../../common/messages/messages";
import {
  GetAllVoyagesBetweenRequest,
  GetVoyageByIdRequest,
  GetVoyageByVesselImoRequest,
  SubmitNorRequest,
  UpdateVoyageRequest,
  Voyage,
  VoyageResponse,
  VoyagesReponse,
} from "./voyage";

import { VoyageServiceClientImpl } from "./voyage";

@Injectable({ providedIn: "root" })
export class VoyageServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async updateNor(request: SubmitNorRequest): Promise<EmptyResponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.updateNor(request);
  }
  async getVoyageById(request: GetVoyageByIdRequest): Promise<VoyageResponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.getVoyageById(request);
  }
  async addVoyage(request: Voyage): Promise<VoyageResponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.addVoyage(request);
  }
  async updateVoyage(request: UpdateVoyageRequest): Promise<VoyageResponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.updateVoyage(request);
  }
  async getPreviousVoyageById(request: GetVoyageByIdRequest): Promise<VoyageResponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.getPreviousVoyageById(request);
  }
  async getNextVoyageById(request: GetVoyageByIdRequest): Promise<VoyageResponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.getNextVoyageById(request);
  }
  async getVoyagesByImo(request: GetVoyageByVesselImoRequest): Promise<VoyagesReponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.getVoyagesByImo(request);
  }
  async getAllVoyagesBetween(request: GetAllVoyagesBetweenRequest): Promise<VoyagesReponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.getAllVoyagesBetween(request);
  }
  async getLatestVoyages(request: EmptyRequest): Promise<VoyagesReponse> {
    const client = new VoyageServiceClientImpl(this._rpc);
    return await client.getLatestVoyages(request);
  }
}
